import axios from 'axios'
import global from '../../global';
import * as token from '../utils/token';

// Axios
// 创建 axios 实例
const service = axios.create({
    baseURL: global.apiBaseUrl, 
    timeout: 30000, // request timeout
})


//  请求拦截器
service.interceptors.request.use(
    (config) => {
        if (config.download) {
            config.responseType = 'blob';
            config.loading = "下载中";
        }
		
        //显示loading
        if (config.loading != undefined) {
			//beginLoad方法定义在vue-prototype.js里
			// 展示加载弹层
            V.beginLoad({
                text: config.loading
            });
        }
		
		// 头文件内容
        if (config.auth) {
            config.headers['auth'] = token.getToken();
        }
		
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        config.headers['Accept'] = 'application/json;charset=UTF-8';
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        if (response.config.loading != undefined) {
			//endLoad方法定义在vue-prototype.js里
			// 隐藏Loading
            V.endLoad();
        }
        const res = response.data;
		
		// 如果是下载方法，就全部返回
        if (response.config.download) {
            return res;
        }
		
        if (res.Code === 100) {
            return res.Data
        } else if (res.Code == 203) {
            return {
                Status: 0,
                Data: "暂无权限"
            };
        } else {
            //授权失败
            return Promise.reject({
                Status: -2,
                Data: "授权失败"
            })
        }
    },
    (error) => {
        V.endLoad();
        V.alertError(error, 2000);
        console.log("myerror", error);
        //响应错误
        return Promise.reject(error)
    }
)

export default service